import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import actions from "../Store/actions";
import styles from "./styles";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { polyfillLoader } from "polyfill-io-feature-detection";
import config from "../config";

// This function load polyfills only if needed. By default it uses polyfill.io
polyfillLoader({
    features: "Promise"
});

// TODO: reportId & datasetId should be fetched from DB rather than config file

/**
 * PowerBI Dashboard Reports Component
 */
export default () => {
    const classes = makeStyles(styles)();
    const dispatch = useDispatch();
    const { userOrganisations } = useSelector((state) => state);

    const organisationId = userOrganisations.item.id;
    const embedUrl = "https://app.powerbi.com/reportEmbed?reportId=";

    const organisationForAuditGroupFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
            table: "Organisation for Audit Group",
            column: "Organisation Id"
        },
        operator: "In",
        values: [organisationId],
        filterType: models.FilterType.BasicFilter,
        requireSingleSelection: true
    };
    const organisationFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
            table: "Organisation",
            column: "Organisation Id"
        },
        operator: "In",
        values: [organisationId],
        filterType: models.FilterType.BasicFilter,
        requireSingleSelection: true
    };

    const [reportEmbedConfig, setReportConfig] = useState({
        type: "report",
        id: config.powerBI.dashboard.reportId,
        embedUrl: embedUrl,
        accessToken: undefined,
        tokenType: models.TokenType.Embed,
        filters: [organisationFilter, organisationForAuditGroupFilter],
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false
                },
                pageNavigation: {
                    visible: false
                }
            },
            background: models.BackgroundType.Transparent
        }
    });

    useEffect(() => {
        let mounted = true;
        (async () => {
            const pbiPost = {
                datasets_id: config.powerBI.dashboard.datasetId,
                reports_id: config.powerBI.dashboard.reportId,
                organisation_id: userOrganisations.item.id
            };
            const accessTokenDispatch = await dispatch(
                actions.powerbi.create.postRequest(pbiPost)
            );
            if (mounted) {
                setReportConfig({
                    ...reportEmbedConfig,
                    id: config.powerBI.dashboard.reportId,
                    accessToken: accessTokenDispatch
                });
            }
        })();
        /* Cancel all subscriptions and asynchronous tasks in a useEffect 
        cleanup function */
        return () => (mounted = false);
    }, []);

    return (
        <Grid container className={classes.pageMainContainer}>
            <Grid container className={classes.reportMainContainer}>
                <PowerBIEmbed
                    embedConfig={reportEmbedConfig}
                    eventHandlers={
                        new Map([
                            [
                                "loaded",
                                function () {
                                    // console.log('Report loaded');
                                }
                            ],
                            [
                                "rendered",
                                function () {
                                    // console.log('Report rendered');
                                }
                            ],
                            [
                                "error",
                                function (event) {
                                    console.log(event.detail);
                                }
                            ]
                        ])
                    }
                    cssClassName={"reportMain"}
                    getEmbeddedComponent={(embeddedReport) => {
                        window.report = embeddedReport;
                    }}
                />
            </Grid>
        </Grid>
    );
};
